import * as yup from 'yup';

export const cupomSchema = yup.object().shape({
  codigo: yup
    .string().required(),
  desconto: yup
    .number()
    .required()
    .positive(),
  email: yup
    .string()
    .required(),
  aplicavel: yup
    .string()
    .required()
})